<template>
  <div class="page-wrapper">
    <div class="item" v-for="(item,index) in zoList" :key="'keyA'+index">
      <img class="head-img"  :src="item.headPic" alt="zo头像">
      <div class="desc">{{item.zoName}}</div>
      <div class="desc">{{item.selfIntro}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name:'ZoInfo',
    props:{
      zoList: {
        type: Array,
        default: []
      }
    },
    components:{
    },
    data(){
      return {
      }
    },
    watch:{
    },
    methods:{
    },
    created(){
    }
  }
</script>
<style scoped>
  .item{
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .head-img{
    display: block;
    width: 260px;
    height: 170px;
    margin-bottom: 5px;
  }
  .name{
    display: block;
    line-height: 2;
    font-weight: bold;
    color: #444444;
  }

</style>
